export { default } from './ProductCollection'
